/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';

@Injectable({ providedIn: 'root' })
export class SmartAssistantFileShareStrService {
    get = this.i18nService.get;

    i18n = {
        helpTitle: this.get('service.share_simplifiedMode_setPermission_title'),
        helpText: this.get('service.share_simplifiedMode_setPermission_info'),
        nfsLabel: this.get('common.nfsShare_lab'),
        cifsLabel: this.get('common.cifsShare_lab'),
        setPermission: this.get('service.share_simplifiedMode_setPermission_btn'),
        gifTip1: this.get('home.smartAssistant_filesystem_shareFigure1_info'),
        gifTip2: this.get('home.smartAssistant_filesystem_shareFigure2_info'),
        createFileShareTitle: this.get('service.share_simplifiedMode_create_wintitle'),
    };
    /**
     * 文件共享动图下的文字内容
     */
    fileShareGifTips = [this.i18n.gifTip1, this.i18n.gifTip2];

    constructor(private i18nService: I18nService) { }
}
